import React from 'react';
import { Wrapper, SubTitle, Content, ExternalLink } from './Thanks.styled.js'
import Title from '@components/molecules/Title/Title';

const Thanks = () => {
  return (
    <Wrapper data-testid="test_thanks">
      <Title title="Merci" context="thanks" />
      <Content>
        <p>L'École Française vous remercie pour votre inscription.<br />
          Vous serez recontacté très bientôt par un membre de notre équipe.</p>

        <SubTitle>Connaissez-vous le montant de vos droits formation ?</SubTitle>
        <p>Si vous avez travaillé en France, <b>vous en possédez <u>forcément</u></b>, même sans le savoir…</p>
        <p>Vous pouvez créer votre espace <b>mon compte formation</b>, en une minute, sur
          <ExternalLink href="https://www.moncompteformation.gouv.fr/espace-prive/html/" target="_blank" rel="noopener">
            le site gouvernemental
          </ExternalLink>
        </p>
      </Content>
    </Wrapper>
  )
}

export default Thanks;
